import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { ATSResumeJson } from '@/types/resume';
import { styles } from '@/components/common/AtsResumePdfStyles';
import { parseRichText } from './PdfUtils';

interface PdfEducationProps {
  data: ATSResumeJson;
  showChanges?: boolean;
}

export const PdfEducation = React.memo<PdfEducationProps>(({ data, showChanges = false }) => {
  if (!data.education || data.education.length === 0) return null;

  return (
    <View style={styles.section}>
      <Text style={styles.sectionTitle}>Education</Text>
      <View style={styles.sectionUnderline} />
      {data.education.map((edu, idx) => (
        <View key={idx} style={styles.educationItem} wrap={false}>
          <View style={styles.educationHeader}>
            <Text style={styles.educationDegree}>
              {parseRichText(edu.degree, showChanges)} — <Text style={styles.educationInstitution}>{parseRichText(edu.institution, showChanges)}</Text>
            </Text>
            <Text style={styles.educationDate}>
              {parseRichText(`${edu.startDate} – ${edu.endDate}`, showChanges)}
            </Text>
          </View>
        </View>
      ))}
    </View>
  );
});
